import axios from "axios";
import ExcelJS from "exceljs";
import getAddressLatLong from "./getAddressLatLong";

// Empty values come back as null, same as before.
const cellValue = (cell) => {
  let v = cell?.value;

  if (v && typeof v === "object" && !(v instanceof Date)) {
    if ("formula" in v || "sharedFormula" in v) {
      v = v.result; // cached formula result
    } else if (Array.isArray(v.richText)) {
      v = v.richText.map((t) => t.text).join("");
    } else if ("hyperlink" in v) {
      v = v.hyperlink || v.text;
    } else if ("text" in v) {
      v = v.text;
    } else {
      v = null; // error values etc.
    }
  }

  if (v == null) return null;
  if (typeof v === "string" && v.trim() === "") return null;
  return v;
};
const ExtractDataFromExcel = async (uploadedExcelLink) => {
  let locations = [];
  let products = [];
  let totalArea = 0; // Initialize total area counter

  if (uploadedExcelLink) {
    const response = await axios.get(uploadedExcelLink, {
      responseType: "arraybuffer", // Ensure buffer is returned
    });
    // Initialize the Excel workbook and read the uploaded file
    const workbook = new ExcelJS.Workbook();
    // await workbook.xlsx.readFile(file.path);
    await workbook.xlsx.load(response.data);
    // Get the first sheet in the workbook
    const worksheet = workbook.worksheets[0];
    // Iterate through rows starting from the second row (assuming the first row is header)
    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      // Skip the first row (header row)
      if (rowNumber === 1) return;
      // Extract the values from each cell in the row

      const hasUserData = [1, 2, 3, 4, 5, 6, 7].some(
        (col) => cellValue(row.getCell(col)) !== null,
      );
      if (!hasUserData) return;
      const rowData = {
        storeName: cellValue(row.getCell(1)),
        storeOwnerName: cellValue(row.getCell(2)),
        storeOwnerPhoneNumber: cellValue(row.getCell(3)),
        address: cellValue(row.getCell(4)),
        city: cellValue(row.getCell(5)),
        state: cellValue(row.getCell(6)),
        zipCode: cellValue(row.getCell(7)),
        driverName: cellValue(row.getCell(11)),
        driverPhoneNumber: cellValue(row.getCell(12)),
        driverVehicleNumber: cellValue(row.getCell(13)),
        zone: cellValue(row.getCell(8)),
        landmark: cellValue(row.getCell(9)),
        locationLink: cellValue(row.getCell(10)),
        soName: cellValue(row.getCell(14)),
        soPhoneNumber: cellValue(row.getCell(15)),
      };
      const rowDataForProducts = {};
      //   productType: row.getCell(9).value
      //     ? row.getCell(9).value.toString().trim()
      //     : "",
      //   productWidth: parseFloat(row.getCell(10).value) || 0, // Ensure numeric value
      //   productHeight: parseFloat(row.getCell(11).value) || 0, // Ensure numeric value
      //   productThickness: row.getCell(12).value,
      // };

      // Calculate area for this product and add to total
      const area = 0;
      // rowDataForProducts?.productHeight * rowDataForProducts?.productWidth;
      totalArea += area;

      // Add the row data to the lists
      locations.push({
        details: rowData,
        area: area, // Store individual area for reference
      });
      products.push(rowDataForProducts);
    });

    if (locations.length !== 0) {
      await Promise.all(
        locations.map(async (location, index) => {
          // let result = await getAddressLatLong(
          //   location.details.address,
          //   location.details.city,
          //   location.details.state,
          //   location.details.zipCode
          // );
          let result = { lat: "", lng: "" };
          location.locationCoordinates = result;
          location.product = products[index];
        }),
      );
    }
  }

  return {
    locations,
    totalArea: totalArea.toFixed(2), // Return total area rounded to 2 decimal places
  };
};
export default ExtractDataFromExcel;
